import { render, staticRenderFns } from "./MagneticInductionViz.vue?vue&type=template&id=6300f2d4&scoped=true"
import script from "./MagneticInductionViz.vue?vue&type=script&lang=js"
export * from "./MagneticInductionViz.vue?vue&type=script&lang=js"
import style0 from "./MagneticInductionViz.vue?vue&type=style&index=0&id=6300f2d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6300f2d4",
  null
  
)

export default component.exports